import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { B200, N0, N10, N100, N200, N900, R400 } from '@atlaskit/theme/colors';
import { FormGrid } from '../../../common/ui/FormGrid/styled';
export { FormGrid };

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ErrorWrapper = styled.span({
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var Label = styled.label({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  fontWeight: "var(--ds-font-weight-semibold, 600)",
  color: "var(--ds-text-subtlest, ".concat(N200, ")"),
  display: 'block'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var LabelSpan = styled.span({
  display: 'block',
  marginBottom: "var(--ds-space-050, 4px)"
});
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var Field = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tbackground-color: ", ";\n\tborder-color: ", ";\n\tborder-radius: 3px;\n\tborder-width: ", ";\n\tborder-style: solid;\n\tbox-sizing: border-box;\n\ttransition:\n\t\tbackground-color 0.2s ease-in-out,\n\t\tborder-color 0.2s ease-in-out;\n\tpadding: 10px ", ";\n\t&:focus-within {\n\t\tborder-color: ", ";\n\t\tbox-shadow: inset 0 0 0 ", " ", ";\n\t}\n"])), function (_ref) {
  var focused = _ref.focused;
  return focused ? "var(--ds-background-input-pressed, ".concat(N0, ")") : "var(--ds-background-input, ".concat(N10, ")");
}, function (_ref2) {
  var focused = _ref2.focused,
    error = _ref2.error;
  if (error) {
    return focused ? "var(--ds-border-focused, ".concat(B200, ")") : "var(--ds-border-danger, ".concat(R400, ")");
  } else {
    return focused ? "var(--ds-border-focused, ".concat(B200, ")") : "var(--ds-border-input, ".concat(N100, ")");
  }
}, "var(--ds-border-width, 1px)", "var(--ds-space-075, 6px)", "var(--ds-border-focused, ".concat(B200, ")"), "var(--ds-border-width, 1px)", "var(--ds-border-focused, ".concat(B200, ")"));
export var inputOptions = {
  style: {
    base: {
      // this style will be used in another iframe with different base settings
      // we have to use absolute, body-styles independent units
      font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
      color: "var(--ds-text, ".concat(N900, ")"),
      '::placeholder': {
        color: "var(--ds-text-subtlest, ".concat(N200, ")")
      }
    },
    invalid: {
      color: "var(--ds-text-danger, ".concat(R400, ")")
    }
  }
};